import EditRequirementTypeContainer from "./EditRequirementTypeContainer";
export default EditRequirementTypeContainer;
